// src/router/index.js

import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 定义路由
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/index.vue')
  },
  {
    // 图片主页
    path: '/picture',
    name: 'Picture',
    component: () => import(/* webpackChunkName: "home" */ '../views/picture.vue')
  },
  {
    // 图片列表页
    path: '/pictureList',
    name: 'PictureList',
    component: () => import(/* webpackChunkName: "home" */ '../views/pictureList.vue')
  },
  {
    // 图片详情页
    path: '/pictureDetail',
    name: 'PictureDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/pictureDetail.vue')
  },
  {
    // 视频主页
    path: '/videoList',
    name: 'VideoList',
    component: () => import(/* webpackChunkName: "home" */ '../views/videoList.vue')
  },
  {
    // 视频列表页
    path: '/video',
    name: 'Video',
    component: () => import(/* webpackChunkName: "home" */ '../views/video.vue')
  },
  {
    // 视频详情页
    path: '/videoDetail',
    name: 'VideoDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/videoDetail.vue')
  },
  {
    // 登录
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "home" */ '../views/login.vue')
  },
  {
    // 微信登录中间页
    path: '/wechatCallback',
    name: 'WechatCallback',
    component: () => import(/* webpackChunkName: "home" */ '../views/wechatCallback.vue')
  },
  {
    // 注册
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "home" */ '../views/register.vue')
  },
    {
    // 微信登录绑定账号
    path: '/bindAccount',
    name: 'BindAccount',
    component: () => import(/* webpackChunkName: "home" */ '../views/bindAccount.vue')
  },
  {
    // 重置密码
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "home" */ '../views/resetPassword.vue')
  },
  {
    // 商家中心
    path: '/business',
    name: 'Business',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/index.vue')
  },
  {
    // 商家中心-企业首页
    path: '/business/companyIndex',
    name: 'CompanyIndex',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyIndex.vue')
  },
  {
    // 商家中心-企业案例
    path: '/business/companyCase',
    name: 'CompanyCase',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyCase.vue')
  },
  {
    // 商家中心-企业案例详情
    path: '/business/companyCaseDetail',
    name: 'CompanyCaseDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyCaseDetail.vue')
  },
  {
    // 商家中心-企业联系我们
    path: '/business/companyAboutUs',
    name: 'CompanyAboutUs',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyAboutUs.vue')
  },
  {
    // 商家中心-企业图片
    path: '/business/companyImg',
    name: 'CompanyImg',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyImg.vue')
  },
  {
    // 商家中心-企业视频
    path: '/business/companyVideo',
    name: 'CompanyVideo',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyVideo.vue')
  },
  {
    // 商家中心-企业资料下载
    path: '/business/companyDownload',
    name: 'CompanyDownload',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyDownload.vue')
  },
  {
    // 商家中心-企业资料下载详情
    path: '/business/companyDownloadDetail',
    name: 'CompanyDownloadDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyDownloadDetail.vue')
  },
  {
    // 商家中心-企业资讯
    path: '/business/companyNew',
    name: 'CompanyNew',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyNew.vue')
  },
  {
    // 商家中心-企业入驻
    path: '/business/companyJoin',
    name: 'CompanyJoin',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyJoin.vue')
  },
  {
    // 商家中心-产品中心
    path: '/business/companyPro',
    name: 'CompanyPro',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyPro.vue')
  },
  {
    // 商家中心-技术服务
    path: '/business/companySkill',
    name: 'CompanySkill',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companySkill.vue')
  },
  {
    // 商家中心-技术服务详情
    path: '/business/companySkillDetail',
    name: 'CompanySkillDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companySkillDetail.vue')
  },
  {
    // 商家中心-新闻详情
    path: '/business/companyNewDetail',
    name: 'CompanyNewDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyNewDetail.vue')
  },
  {
    // 商家中心-产品详情
    path: '/business/companyProDetail',
    name: 'companyProDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyProDetail.vue')
  },
  {
    // 商家中心-视频详情
    path: '/business/companyVideoDetail',
    name: 'CompanyVideoDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyVideoDetail.vue')
  },
  {
    // 商家中心-图片详情
    path: '/business/companyImgDetail',
    name: 'CompanyImgDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyImgDetail.vue')
  },
  {
    // 商家中心-专家风采
    path: '/business/companyExpert',
    name: 'CompanyExpert',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyExpert.vue')
  },
  {
    // 商家中心-专家风采详情
    path: '/business/companyExpertDetail',
    name: 'CompanyExpertDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/business/companyExpertDetail.vue')
  },
  {
    // 数据中心-产品页
    path: '/dataCenter/product',
    name: 'Product',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/product.vue')
  },
  {
    // 数据中心-产品列表页
    path: '/dataCenter/productList',
    name: 'ProductList',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/productList.vue')
  },
  {
    // 数据中心-产品列表页
    path: '/dataCenter/industry',
    name: 'Industry',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/industry.vue')
  },
  {
    // 数据中心-产品列表页
    path: '/dataCenter/industryDetail',
    name: 'IndustryDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/industryDetail.vue')
  },
  {
    // 数据中心-产品列表页
    path: '/dataCenter/profession',
    name: 'Profession',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/profession.vue')
  },
  {
    // 数据中心-产品详情页
    path: '/dataCenter/professionDetail',
    name: 'ProfessionDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/professionDetail.vue')
  },
  {
    // 数据中心-技术服务
    path: '/dataCenter/technology',
    name: 'Technology',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/technology.vue')
  },
  {
    // 数据中心-技术服务详情
    path: '/dataCenter/technologyDetail',
    name: 'TechnologyDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/technologyDetail.vue')
  },
  {
    // 数据中心-商品详情页
    path: '/dataCenter/productDetail',
    name: 'ProductDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/productDetail.vue')
  },
  {
    // 数据中心-首页
    path: '/dataCenter/index',
    name: 'dataCenterIndex',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/index.vue')
  },
  {
    // 数据中心-项目
    path: '/dataCenter/project',
    name: 'Project',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/project.vue')
  },
  {
    // 数据中心-项目详情
    path: '/dataCenter/projectDetail',
    name: 'ProjectDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/projectDetail.vue')
  },
  {
    // 数据中心-专家
    path: '/dataCenter/expert',
    name: 'Expert',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/expert.vue')
  },
  {
    // 数据中心-专家详情
    path: '/dataCenter/expertDetail',
    name: 'ExpertDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/dataCenter/expertDetail.vue')
  },
  {
    // 行业资讯
    path: '/new',
    name: 'New',
    component: () => import(/* webpackChunkName: "home" */ '../views/new.vue')
  },
  {
    // 行业资讯详情
    path: '/newDetail',
    name: 'NewDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/newDetail.vue')
  },
  {
    // 个人中心-首页
    path: '/user/index',
    name: 'userIndex',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/index.vue')
  },
  {
    // 个人中心-他人中心
    path: '/user/userIndex',
    name: 'UserIndex',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/userIndex.vue')
  },
  {
    // 个人中心-编辑资料
    path: '/user/editUser',
    name: 'EditUser',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/editUser.vue')
  },
  {
    // 个人中心-通讯录
    path: '/user/addressBook',
    name: 'AddressBook',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/addressBook.vue')
  },
  {
    // 个人中心-朋友圈
    path: '/user/friends',
    name: 'Friends',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/friends.vue')
  },
  {
    // 个人中心-人脉圈
    path: '/user/relationship',
    name: 'Relationship',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/relationship.vue')
  },
  {
    // 个人中心-下载管理-视频
    path: '/user/downloadVideo',
    name: 'DownloadVideo',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/downloadVideo.vue')
  },
  {
    // 个人中心-下载管理-图片
    path: '/user/downloadImg',
    name: 'DownloadImg',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/downloadImg.vue')
  },
  {
    // 个人中心-下载管理-文档
    path: '/user/downloadDocument',
    name: 'DownloadDocument',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/downloadDocument.vue')
  },
  {
    // 个人中心-我的发布-供需
    path: '/user/supply',
    name: 'Supply',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/supply.vue')
  },
  {
    // 个人中心-我的发布-技术问答
    path: '/user/technology',
    name: 'Technology',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/technology.vue')
  },
  {
    // 个人中心-我的接单
    path: '/user/orderTaking',
    name: 'OrderTaking',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/orderTaking.vue')
  },
  {
    // 个人中心-我的接单
    path: '/user/signUp',
    name: 'SignUp',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/signUp.vue')
  },
  {
    // 个人中心-我的收藏
    path: '/user/collect',
    name: 'Collect',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/collect.vue')
  },
  {
    // 个人中心-我的收藏详情
    path: '/user/collectDetail',
    name: 'CollectDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/collectDetail.vue')
  },
  {
    // 个人中心-企业中心-Banner管理
    path: '/user/system/banner',
    name: 'Banner',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/banner.vue')
  },
  {
    // 个人中心-企业中心-新增Banner
    path: '/user/system/addBanner',
    name: 'AddBanner',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addBanner.vue')
  },
  {
    // 个人中心-企业中心-编辑Banner
    path: '/user/system/editBanner',
    name: 'EditBanner',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editBanner.vue')
  },
  {
    // 个人中心-企业中心-链接
    path: '/user/system/link',
    name: 'Link',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/link.vue')
  },
  {
    // 个人中心-企业中心-新增链接
    path: '/user/system/addLink',
    name: 'AddLink',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addLink.vue')
  },
  {
    // 个人中心-企业中心-新增链接
    path: '/user/system/editLink',
    name: 'EditLink',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editLink.vue')
  },
  {
    // 个人中心-企业中心-留言管理
    path: '/user/system/message',
    name: 'Message',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/message.vue')
  },
  {
    // 个人中心-企业中心-留言详情
    path: '/user/system/messageDetail',
    name: 'MessageDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/messageDetail.vue')
  },
  {
    // 个人中心-企业中心-案例
    path: '/user/system/case',
    name: 'Case',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/case.vue')
  },
  {
    // 个人中心-企业中心-新增案例
    path: '/user/system/addCase',
    name: 'AddCase',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addCase.vue')
  },
  {
    // 个人中心-企业中心-编辑案例
    path: '/user/system/editCase',
    name: 'EditCase',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editCase.vue')
  },
  {
    // 个人中心-企业中心-产品管理
    path: '/user/system/product',
    name: 'Product',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/product.vue')
  },
  {
    // 个人中心-企业中心-新增产品
    path: '/user/system/addProduct',
    name: 'AddProduct',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addProduct.vue')
  },
  {
    // 个人中心-企业中心-新增产品
    path: '/user/system/editProduct',
    name: 'EditProduct',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editProduct.vue')
  },
  {
    // 个人中心-企业中心-技术服务
    path: '/user/system/technology',
    name: 'Technology',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/technology.vue')
  },
  {
    // 个人中心-企业中心-新增技术服务
    path: '/user/system/addTechnology',
    name: 'AddTechnology',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addTechnology.vue')
  },
  {
    // 个人中心-企业中心-编辑技术服务
    path: '/user/system/editTechnology',
    name: 'EditTechnology',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editTechnology.vue')
  },
  {
    // 个人中心-企业中心-图片管理
    path: '/user/system/picture',
    name: 'Picture',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/picture.vue')
  },
  {
    // 个人中心-企业中心-新增图片
    path: '/user/system/addPicture',
    name: 'AddPicture',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addPicture.vue')
  },
  {
    // 个人中心-企业中心-编辑图片
    path: '/user/system/editPicture',
    name: 'EditPicture',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editPicture.vue')
  },
  {
    // 个人中心-企业中心-视频管理
    path: '/user/system/video',
    name: 'Video',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/video.vue')
  },
  {
    // 个人中心-企业中心-新增视频
    path: '/user/system/addVideo',
    name: 'AddVideo',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addVideo.vue')
  },
  {
    // 个人中心-企业中心-编辑视频
    path: '/user/system/editVideo',
    name: 'EditVideo',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editVideo.vue')
  },
  {
    // 个人中心-企业中心-资讯管理
    path: '/user/system/new',
    name: 'New',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/new.vue')
  },
  {
    // 个人中心-企业中心-新增资讯
    path: '/user/system/addNew',
    name: 'AddNew',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addNew.vue')
  },
  {
    // 个人中心-企业中心-编辑资讯
    path: '/user/system/editNew',
    name: 'EditNew',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editNew.vue')
  },
  {
    // 个人中心-企业中心-资料管理
    path: '/user/system/information',
    name: 'Information',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/information.vue')
  },
  {
    // 个人中心-企业中心-新增资料管理
    path: '/user/system/addInformation',
    name: 'AddInformation',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addInformation.vue')
  },
  {
    // 个人中心-企业中心-新增资料管理
    path: '/user/system/editInformation',
    name: 'EditInformation',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editInformation.vue')
  },
  {
    // 个人中心-企业中心-专家管理
    path: '/user/system/expert',
    name: 'Expert',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/expert.vue')
  },
  {
    // 个人中心-企业中心-新增专家
    path: '/user/system/addExpert',
    name: 'AddExpert',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/addExpert.vue')
  },
  {
    // 个人中心-企业中心-修改专家
    path: '/user/system/editExpert',
    name: 'EditExpert',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/editExpert.vue')
  },
  {
    // 个人中心-企业中心-联系我们
    path: '/user/system/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/system/contact.vue')
  },
  {
    // 个人中心-会员权益
    path: '/user/vip',
    name: 'Vip',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/vip.vue')
  },
  {
    // 个人中心-会员购买
    path: '/user/vipPay',
    name: 'VipPay',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/vipPay.vue')
  },
  {
    // 个人中心-购买成功
    path: '/user/paySuccess',
    name: 'PaySuccess',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/paySuccess.vue')
  },
  {
    // 服务协议
    path: '/agreement',
    name: 'Agreement',
    component: () => import(/* webpackChunkName: "home" */ '../views/agreement.vue')
  },
  {
    // 会议活动-首页
    path: '/exhibition',
    name: 'exhibition',
    component: () => import(/* webpackChunkName: "home" */ '../views/exhibition/index.vue')
  },
  {
    // 会议活动-详情页
    path: '/exhibition/detail',
    name: 'exhibitionDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/exhibition/detail.vue')
  },
  {
    // 会议活动-会议报名
    path: '/exhibition/signUp',
    name: 'exhibitionSignUp',
    component: () => import(/* webpackChunkName: "home" */ '../views/exhibition/signUp.vue')
  },
  {
    // 更多帮助-帮助中心
    path: '/moreServices/helpCenter',
    name: 'HelpCenter',
    component: () => import(/* webpackChunkName: "home" */ '../views/moreServices/helpCenter.vue')
  },
  {
    // 更多帮助-行业词条
    path: '/moreServices/industryEntry',
    name: 'IndustryEntry',
    component: () => import(/* webpackChunkName: "home" */ '../views/moreServices/industryEntry.vue')
  },
  {
    // 更多帮助-行业词条详情
    path: '/moreServices/industryEntryDetail',
    name: 'IndustryEntryDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/moreServices/industryEntryDetail.vue')
  },
  {
    // 更多帮助-资料下载
    path: '/moreServices/dataDownLoad',
    name: 'DataDownLoad',
    component: () => import(/* webpackChunkName: "home" */ '../views/moreServices/dataDownLoad.vue')
  },
  {
    // 更多帮助-资料下载详情
    path: '/moreServices/dataDownLoadDetail',
    name: 'DataDownLoadDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/moreServices/dataDownLoadDetail.vue')
  },
  {
    // 供需服务首页
    path: '/demand/index',
    name: 'DemandIndex',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/index.vue')
  },
  {
    // 供需服务详情
    path: '/demand/detail',
    name: 'DemandDetail',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/detail.vue')
  },
  {
    // 供需服务-接单
    path: '/demand/orderTaking',
    name: 'OrderTaking',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/orderTaking.vue')
  },
  {
    // 供需服务-采购助手
    path: '/demand/purchase',
    name: 'Purchase',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/purchase.vue')
  },
  {
    // 供需服务-采购助手编辑
    path: '/demand/editPurchase',
    name: 'EditPurchase',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/editPurchase.vue')
  },
  {
    // 供需服务-代理销售
    path: '/demand/agent',
    name: 'Agent',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/agent.vue')
  },
  {
    // 供需服务-代理销售编辑
    path: '/demand/editAgent',
    name: 'EditAgent',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/editAgent.vue')
  },
  {
    // 供需服务-对接服务
    path: '/demand/docking',
    name: 'Docking',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/docking.vue')
  },
  {
    // 供需服务-对接服务编辑
    path: '/demand/editDocking',
    name: 'EditDocking',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/editDocking.vue')
  },
  {
    // 供需服务-对接服务
    path: '/demand/release',
    name: 'Release',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/release.vue')
  },
  {
    // 供需服务-对接服务修改
    path: '/demand/editRelease',
    name: 'EditRelease',
    component: () => import(/* webpackChunkName: "home" */ '../views/demand/editRelease.vue')
  },
  {
    // 数字中心首页
    path: '/digitalCenter/index',
    name: 'DigitalCenterIndex',
    component: () => import(/* webpackChunkName: "home" */ '../views/digitalCenter/index.vue')
  },
  {
    // 数字中心结果页
    path: '/digitalCenter/result',
    name: 'DigitalCenterResult',
    component: () => import(/* webpackChunkName: "home" */ '../views/digitalCenter/result.vue')
  },
  {
    // 个人中心-修改密码
    path: '/user/editPassword',
    name: 'EditPassword',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/editPassword.vue')
  },
  {
    // 个人中心-实名认证
    path: '/user/authentication',
    name: 'Authentication',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/authentication.vue')
  },
  {
    // 个人中心-实名认证
    path: '/user/authentication',
    name: 'Authentication',
    component: () => import(/* webpackChunkName: "home" */ '../views/user/authentication.vue')
  },
  {
    // 更多服务-论坛
    path: '/moreServices/forum',
    name: 'Forum',
    component: () => import(/* webpackChunkName: "home" */ '../views/moreServices/forum.vue')
  },
];

// 创建 Router 实例
const router = new VueRouter({
  mode: 'history', // 可选：'hash' | 'history'
  base: process.env.BASE_URL,
  routes
});
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 滚动到顶部
  window.scrollTo(0, 0);
  next();
});
export default router;